import axios from 'axios';
import difference from 'lodash/difference';
import flatten from 'lodash/flatten';
import { loadFiles, log } from 'loader-base';
import { getBasePath, getBundleFiles } from './bundle-helper';
import { getBowerDependencies } from './component-helper';
import { dashesToCamel, camelToDashes } from './util';

let loadedFiles;

function loadWithSelfCDN(loaderConfig) {
    return new Promise((resolve) => {
        let dependencyList = [];
        const bundleFileOverrides = loaderConfig.componentSource.overrides || {};

        let fileList;

        Object.keys(loaderConfig.resolvedDependencies).forEach((name) => {
            const bundleFiles = bundleFileOverrides[dashesToCamel(name)] || bundleFileOverrides[camelToDashes(name)];
            const { version } = loaderConfig.resolvedDependencies[name];
            // firstly use override bundles
            // secondly use the client special bundles
            // finally use the default version bundles
            if (bundleFiles && bundleFiles.length) {
                fileList = bundleFiles;
            } else if (version) {
                fileList = getBundleFiles(loaderConfig.componentSource.environment, name, version, loaderConfig.resolvedDependencies[name].instid, loaderConfig.componentSource.type);
            } else {
                fileList = [];
                log.error('Cannot find the bundle files for component: %s', name);
            }
            // make sure angular is in the first one of the load list
            if (name === 'angular') {
                dependencyList.unshift(fileList);
            } else {
                dependencyList.push(fileList);
            }
        });

        dependencyList = flatten(dependencyList);

        // filter the load list with loaded list
        dependencyList = difference(dependencyList, Array.from(loadedFiles));

        const manifest = {
            loaderConfig,
            config: loaderConfig.config,
            resolutions: fileList,
        };

        loadFiles(dependencyList).then((loadedList) => {
            Object.keys(loadedList).forEach((file) => {
                loadedFiles.add(file);
            });
            resolve(manifest);
        });
    });
}

function loadComponentIndexHandler(loaderConfig) {
    return new Promise((resolve) => {
        loaderConfig.resolvedDependencies = getBowerDependencies(loaderConfig);
        loaderConfig.validBundles = loaderConfig.validBundles || {};
        loadWithSelfCDN(loaderConfig).then(manifest => resolve(manifest));
    });
}

/**
 * Retrieves a list of available bundles (with versions) and downloads the bundles specified in the loader configuration.
 * @param {*} loaderConfig
 * @param {set} loadedList - A set with all previously loaded files on the page
 * @returns {Promise} - Resolves with a manifest containing the loader configuration, app config and a list of the loaded files.
 */
const bundlesReady = function bundlesReady(loaderConfig, loadedList) {
    return new Promise((resolve, reject) => {
        loadedFiles = loadedList || new Set();
        axios({
            method: 'get',
            url: `${getBasePath(loaderConfig.componentSource.environment, loaderConfig.componentSource.type)}/components.json?_=${new Date().getTime()}`,
        }).then((res) => {
            loaderConfig.validBundles = res.data;
            loadComponentIndexHandler(loaderConfig).then(manifest => resolve(manifest));
        }).catch(() => {
            reject(loaderConfig);
        });
    });
};

export { bundlesReady as default };



// WEBPACK FOOTER //
// ./src/bundle-loader.js